<template>
  <div class="register">
    <Header />
    <div class="register-header">
      <b-container class="register-header-container">
        <b-row class="register-header-row">
          <div class="col-lg-12 col-md-6">
            <div class="register-header">
              <h1>Ubah Data Diri</h1>
              <!-- <p>Mohon isi data berikut agar Anda bisa memulai investasi.</p> -->
            </div>
          </div>
        </b-row>
      </b-container>
    </div>
    <div class="register-form">
      <b-container class="register-form-container">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Identitas Diri</h1>
                <h1>{{ domicile_city_code }}</h1>
                <h1>{{ correspondence_city_code }}</h1>
                <p>Personal Identity</p>
              </div>
            </div>
            <!-- <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Email</h3>
                <p>Email</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="user.individual.email"
                  disabled
                />
              </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>No. Telepon</h3>
                <p>Mobile Phone</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="user.individual.mobile_phone"
                  disabled
                />
              </div>
            </div> -->
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Nama Sesuai KTP</h3>
                <p>Full Name according your ID</p>
                <vs-input
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="ifua_name"
                  disabled
                  requiredx
                />
                <div class="error mt-3" v-if="!$v.ifua_name.required">
                  <p>Wajib diisi</p>
                </div>
                <div class="error mt-3" v-if="!$v.ifua_name.minLength">
                  <p>
                    Nama harus memiliki setidaknya
                    {{ $v.ifua_name.$params.minLength.min }} karakter.
                  </p>
                </div>
              </div>
            </div>
          </b-row>

          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>
                  Alamat Korespondensi <br />
                  <small>Alamat Surat Menyurat</small>
                </h1>
                <p>Correspondence Address</p>
              </div>
            </div>
            <div class="col-lg-8 col-md-6">
              <div class="ekyc-form-input">
                <h3>Alamat</h3>
                <p>Address</p>
                <b-row>
                  <b-form-textarea
                    id="correspondence_address"
                    v-model="correspondence_address"
                    rows="3"
                    class="ml-3"
                    max-rows="6"
                    maxlength="100"
                    required
                    autocomplete="off"
                    :disabled="disabledAddress"
                  ></b-form-textarea>
                </b-row>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_address.required"
                >
                  <p>Wajib diisi</p>
                </div>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_address.minLength"
                >
                  <p>
                    Alamat harus memiliki setidaknya
                    {{ $v.correspondence_address.$params.minLength.min }}
                    karakter.
                  </p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div class="col-lg-4 col-md">
              <div class="ekyc-form-input">
                <h3>Negara</h3>
                <p>Country</p>
                <vs-select
                  :disabled="disabledAddress"
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  @input="selectIdCountry($event)"
                  @change="fetchProvinces()"
                  v-model="correspondence_country_code"
                  name="correspondence_country_code"
                  id="correspondence_country_code"
                  style="width: 100%"
                  required
                >
                  <vs-select-item
                    :key="country.id"
                    :value="country.id"
                    :text="country.country_name"
                    v-for="country in countryList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_country_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-6"
              v-if="correspondence_country_code == 130"
            >
              <div class="ekyc-form-input">
                <h3>Propinsi <span>(Opsional)</span></h3>
                <p>Province</p>
                <vs-select
                  :disabled="disabledAddress"
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="correspondence_province_code"
                  @input="selectIdProvince($event)"
                  @change="fetchCities()"
                  name="correspondence_province_code"
                  id="correspondence_province_code"
                  style="width: 100%"
                  required
                >
                  <vs-select-item
                    :key="province.id"
                    :value="province.id"
                    :text="province.province_name"
                    v-for="province in provinceList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_province_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6"></div>
            <div
              class="col-lg-4 col-md-6"
              v-if="correspondence_country_code == 130"
            >
              <div class="ekyc-form-input">
                <h3>Kota/Kabupaten<span> (Opsional)</span></h3>
                <p>City</p>
                <vs-select
                  :disabled="disabledAddress"
                  autocomplete
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="correspondence_city_code"
                  name="correspondence_city_code"
                  id="correspondence_city_code"
                  style="width: 100%"
                  required
                >
                  <vs-select-item
                    :key="index"
                    :value="city.city_code"
                    :text="city.city_name"
                    v-for="(city, index) in cityList"
                  />
                </vs-select>
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_city_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div
              class="col-lg-2 col-md-6"
              v-if="correspondence_country_code == 130"
            >
              <div class="ekyc-form-input">
                <h3>Kode Pos</h3>
                <p>Postal Code</p>
                <vs-input
                  :disabled="disabledAddress"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="number"
                  v-model="correspondence_postal_code"
                  required
                />
                <div
                  class="error mt-3"
                  v-if="!$v.correspondence_postal_code.required"
                >
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>
                  Alamat Sesuai Identitas <br />
                  <small>Alamat sesuai KTP</small>
                </h1>
                <p>Address as Stated in ID</p>
              </div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-radio">
                <vs-radio
                  v-model="isIdentityAddress"
                  vs-name="isIdentityAddress"
                  vs-value="1"
                  @change="checkIdentityIsCorrespondenceAddress"
                  required
                  >Alamat Sesuai Korespondensi<span>
                    / Address as Correspondence Address</span
                  ></vs-radio
                >
                <vs-radio
                  v-model="isIdentityAddress"
                  vs-name="isIdentityAddress"
                  vs-value="2"
                  @change="checkOtherIdentityIsCorrespondenceAddress"
                  >Alamat Lain <span> / Other Address</span></vs-radio
                >
                <div class="error mt-3" v-if="!$v.isIdentityAddress.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <div v-show="isIdentityAddress === '2'">
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-8 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Alamat</h3>
                  <p>Address</p>
                  <b-row>
                    <b-form-textarea
                      id="identity_address"
                      v-model="identity_address"
                      rows="3"
                      class="ml-3"
                      max-rows="6"
                      maxLength="100"
                      required
                      autocomplete="off"
                    ></b-form-textarea>
                  </b-row>
                  <div class="error mt-3" v-if="!$v.identity_address.required">
                    <p>Wajib diisi</p>
                  </div>
                  <div class="error mt-3" v-if="!$v.identity_address.minLength">
                    <p>
                      Alamat harus memiliki setidaknya
                      {{ $v.identity_address.$params.minLength.min }} karakter.
                    </p>
                  </div>
                </div>
              </div>
            </b-row>

            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Negara</h3>
                  <p>Country</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    @input="selectIdCountry($event)"
                    @change="fetchProvinces()"
                    v-model="identity_country_code"
                    name="identity_country_code"
                    id="identity_country_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="country.id"
                      :value="country.id"
                      :text="country.country_name"
                      v-for="country in countryList"
                    />
                  </vs-select>
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_country_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-6"
                v-if="identity_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Propinsi <span>(Opsional)</span></h3>
                  <p>Province</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="identity_province_code"
                    @input="selectIdProvince($event)"
                    @change="fetchCities()"
                    name="identity_province_code"
                    id="identity_province_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="province.id"
                      :value="province.id"
                      :text="province.province_name"
                      v-for="province in provinceList"
                    />
                  </vs-select>
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_province_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div
                class="col-lg-4 col-md-6"
                v-if="identity_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Kota/Kabupaten<span> (Opsional)</span></h3>
                  <p>City</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="identity_city_code"
                    name="identity_city_code"
                    id="identity_city_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="city.city_code"
                      :text="city.city_name"
                      v-for="(city, index) in cityList"
                    />
                  </vs-select>
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_city_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md" v-if="identity_country_code == 130">
                <div class="ekyc-form-input">
                  <h3>Kode Pos</h3>
                  <p>Postal Code</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="number"
                    v-model="identity_postal_code"
                  />
                  <div
                    class="error mt-3"
                    v-if="!$v.identity_postal_code.required"
                  >
                    <p>Wajib diisi</p>
                  </div>
                </div>
              </div>
            </b-row>
          </div>
          <div>
            <b-jumbotron>
              <hr />
            </b-jumbotron>
          </div>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Alamat Domisili</h1>
                <p>Residential Address</p>
              </div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-radio">
                <vs-radio
                  v-model="isDomicileAddress"
                  vs-name="isDomicileAddress"
                  vs-value="1"
                  @change="checkDomicileIsCorrespondenceAddress"
                  required
                  >Alamat Sesuai Korespondensi<span>
                    / Address as Correspondence Addres</span
                  ></vs-radio
                >
                <vs-radio
                  v-model="isDomicileAddress"
                  vs-name="isDomicileAddress"
                  vs-value="2"
                  @change="checkOtherDomicileIsCorrespondenceAddress"
                  >Alamat Lain <span> / Other Address</span></vs-radio
                >
              </div>
              <div class="error mt-3" v-if="!$v.isDomicileAddress.required">
                <p>Wajib diisi</p>
              </div>
            </div>
          </b-row>
          <div v-show="isDomicileAddress === '2'">
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-8 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Alamat Domisili</h3>
                  <p>Residential Address</p>
                  <b-row>
                    <b-form-textarea
                      id="domicile_address"
                      v-model="domicile_address"
                      rows="3"
                      maxLength="100"
                      class="ml-3"
                      max-rows="6"
                      required
                      autocomplete="off"
                    ></b-form-textarea>
                  </b-row>
                  <div class="error mt-3" v-if="!$v.domicile_address.required">
                    <p>Wajib diisi</p>
                  </div>
                  <div class="error mt-3" v-if="!$v.domicile_address.minLength">
                    <p>
                      Alamat harus memiliki setidaknya
                      {{ $v.domicile_address.$params.minLength.min }} karakter.
                    </p>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row class="justify-content-md-start mb-4">
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-4 col-md">
                <div class="ekyc-form-input">
                  <h3>Negara</h3>
                  <p>Country</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    @input="selectIdCountry($event)"
                    @change="fetchProvinces()"
                    v-model="domicile_country_code"
                    name="domicile_country_code"
                    id="domicile_country_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="country.id"
                      :value="country.id"
                      :text="country.country_name"
                      v-for="country in countryList"
                    />
                  </vs-select>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-6"
                v-if="domicile_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Propinsi <span>(Opsional)</span></h3>
                  <p>Province</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="domicile_province_code"
                    @input="selectIdProvince($event)"
                    @change="fetchCities()"
                    name="domicile_province_code"
                    id="domicile_province_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="province.id"
                      :value="province.id"
                      :text="province.province_name"
                      v-for="province in provinceList"
                    />
                  </vs-select>
                </div>
              </div>
            </b-row>
            <b-row
              class="justify-content-md-start mb-4"
              v-if="domicile_country_code == 130"
            >
              <div class="col-lg-3 col-md-6"></div>
              <div class="col-lg-4 col-md-6">
                <div class="ekyc-form-input">
                  <h3>Kota/Kabupaten<span> (Opsional)</span></h3>
                  <p>City</p>
                  <vs-select
                    autocomplete
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="domicile_city_code"
                    name="domicile_city_code"
                    id="domicile_city_code"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="city.city_code"
                      :text="city.city_name"
                      v-for="(city, index) in cityList"
                    />
                  </vs-select>
                </div>
              </div>
              <div
                class="col-lg-2 col-md-6"
                v-if="domicile_country_code == 130"
              >
                <div class="ekyc-form-input">
                  <h3>Kode Pos</h3>
                  <p>Postal Code</p>
                  <vs-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="number"
                    v-model="domicile_postal_code"
                  />
                </div>
              </div>
            </b-row>
          </div>
          <!-- <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left">
                <h1>Persetujuan</h1>
                <p>Agreement</p>
              </div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-input">
                <h3>Upload Foto Kartu Identitas</h3>
                <p>Upload Photo of Your ID Card</p>
                <b-row>
                  <b-col>
                    <template>
                      <div class="dropbox" v-if="!previewKTP">
                        <span class="mb-4">{{ messageKTP }}</span>
                        <div v-if="errorsKTP" class="errors">
                          <p v-for="(error, index) in errorsKTP" :key="index">
                            {{ error }}
                          </p>
                        </div>
                        <p>
                          Drag your file(s) here to begin<br />
                          or click to browse
                        </p>
                        <div>
                          <input
                            type="file"
                            ref="file"
                            id="file"
                            class="input-file"
                            @change="fileImageKTP"
                            required
                          />
                        </div>
                      </div>
                      <div class="preview text-center" v-if="previewKTP">
                        <img :src="previewKTP" width="320" height="200" />
                        <b-row class="py-2">
                          <b-button
                            class="ml-3 btn-dark"
                            @click="resetImageKTP"
                          >
                            Upload Ulang
                          </b-button>
                        </b-row>
                      </div>
                    </template>
                  </b-col>
                </b-row>
                <div class="error mt-3" v-if="!$v.imageKTP.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left"></div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="ekyc-form-input">
                <h3>Upload Swafoto dengan Kartu Identitas</h3>
                <p>Upload your selfie photo with your ID Card</p>
                <b-row>
                  <b-col>
                    <template>
                      <div class="dropbox" v-if="!previewSelfie">
                        <span class="mb-4">{{ messageSelfie }}</span>
                        <div v-if="errorsSelfie" class="errors">
                          <p
                            v-for="(error, index) in errorsSelfie"
                            :key="index"
                          >
                            {{ error }}
                          </p>
                        </div>
                        <p>
                          Drag your file(s) here to begin<br />
                          or click to browse
                        </p>
                        <div>
                          <input
                            type="file"
                            ref="file"
                            id="file"
                            class="input-file"
                            @change="fileImageSelfie"
                            required
                          />
                        </div>
                      </div>
                      <div class="preview text-center" v-if="previewSelfie">
                        <img :src="previewSelfie" width="320" height="200" />
                        <b-row class="py-2">
                          <b-button
                            class="ml-3 btn-dark"
                            @click="resetImageSelfie"
                          >
                            Upload Ulang
                          </b-button>
                        </b-row>
                      </div>
                    </template>
                  </b-col>
                </b-row>
                <div class="error mt-3" v-if="!$v.imageSelfie.required">
                  <p>Wajib diisi</p>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-6">
              <div class="ekyc-form-input">
                <div class="row selfie-instruction">
                  <div class="col-lg-4 col-md-6 mb-2 text-center">
                    <img
                      src="@/assets/img/ekyc/selfie-instruction.svg"
                      alt="selfie-instruction"
                      class="img-fluid"
                    />
                  </div>
                  <div class="col-lg-8 col-md-6">
                    <h3>Panduan Foto</h3>
                    <ol class="ml-3">
                      <li>
                        Pastikan Foto Wajah dan kartu identitas terlihat jelas.
                        Wajah tidak tertutup kartu identitas.
                      </li>
                      <li>Wajah tidak tertutup kartu identitas.</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="justify-content-md-start mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="register-header text-left"></div>
            </div>
            <div class="col-lg-9 col-md-6">
              <div class="ekyc-form-input">
                <b-row>
                  <div class="col-lg-8 col-md-6">
                    <h3>Tanda Tangan</h3>
                    <p>Signature</p>
                  </div>
                  <div class="col-lg-4 col-md-6 text-right">
                    <b-button class="mt-3 btn-dark" @click="undoSignature">
                      Ulang Tanda Tangan
                    </b-button>
                  </div>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="dropbox-signature">
                      <VueSignaturePad ref="signaturePad" />
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="error mt-3" v-if="!$v.imageSelfie.required">
                <p>Wajib diisi</p>
              </div>
            </div>
          </b-row> -->
          <b-row class="justify-content-end btn-submit-row mb-4">
            <div class="col-lg-2 col-md-6 text-right">
              <b-button
                block
                type="submit"
                :disabled="loading"
                @click.once="handleSubmit()"
                class="btn-tertiary py-2 px-4"
              >
                <div v-if="loading">
                  <div class="spinner-border spinner-border-sm"></div>
                  Loading
                </div>
                <div v-else>Submit</div>
              </b-button>
            </div>
          </b-row>
        </b-form>

        <div class="modal-register">
          <b-modal
            id="modal-failed-register"
            v-model="failedShow"
            size="md"
            class="modal-failed-register"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img
                src="@/assets/img/ekyc/data-not-correct.svg"
                alt="data-not-correct"
              />
              <h1 class="header-modal p-4 my-2 text-dark">
                Isian belum sesuai
              </h1>
              <p>Cek kembali form yang anda isi</p>
              <!-- <p>{{errorMessage}}</p> -->
            </div>
          </b-modal>

          <b-modal
            id="modal-correspondence"
            v-model="failedCorrespondence"
            size="md"
            class="modal-correspondence"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img
                src="@/assets/img/ekyc/data-not-correct.svg"
                alt="data-not-correct"
              />
              <h1 class="header-modal p-4 my-2 text-dark">
                Alamat belum lengkap
              </h1>
              <p>
                Cek kembali detail isian alamat Korespondensi, domisili,
                identitas seperti address, negara, provinsi, kota, dan kode pos
              </p>
            </div>
          </b-modal>

          <b-modal
            id="modal-correspondence"
            v-model="failedDateOfBirth"
            size="md"
            class="modal-correspondence"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img
                src="@/assets/img/ekyc/data-not-correct.svg"
                alt="data-not-correct"
              />
              <h1 class="header-modal p-4 my-2 text-dark">
                Tanggal lahir tidak boleh lebih dari tanggal hari ini
              </h1>
              <p>Cek kembali form yang anda isi</p>
            </div>
          </b-modal>
        </div>
      </b-container>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/partials/header/Header.vue";
import Footer from "@/components/partials/footer/Footer.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import { required, minLength } from "vuelidate/lib/validators";

const instance = axios.create({
  withCredentials: true,
});

export default {
  name: "ChangeProfileIdentity",
  metaInfo: {
    title: "Ganti Profil Identitas | Invesnow.id",
  },
  components: {
    Header,
    Footer,
  },
  validations: {
    ifua_name: {
      required,
      minLength: minLength(3),
    },
    country_code: {
      required,
    },
    correspondence_address: {
      required,
      minLength: minLength(3),
    },
    correspondence_city_code: {
      required,
    },
    correspondence_province_code: {
      required,
    },
    correspondence_country_code: {
      required,
    },
    correspondence_postal_code: {
      required,
    },
    isIdentityAddress: {
      required,
    },
    identity_address: {
      required,
      minLength: minLength(3),
    },
    domicile_address: {
      required,
      minLength: minLength(3),
    },
    identity_province_code: {
      required,
    },
    identity_country_code: {
      required,
    },
    identity_city_code: {
      required,
    },
    identity_postal_code: {
      required,
    },
    isDomicileAddress: {
      required,
    },
  },
  data() {
    return {
      // Production
      ifua_name: "",
      country_code: "ID",
      countries: [],
      country: [],
      identity_address: "",
      identity_province_code: null,
      provinces: [],
      province: [],
      domicile_provinces: [],
      domicile_province: [],
      correspondence_provinces: [],
      correspondence_province: [],
      identity_country_code: null,
      identity_city_code: null,
      cities: [],
      city: [],
      domicile_cities: [],
      domicile_city: [],
      correspondence_cities: [],
      correspondence_city: [],
      identity_postal_code: "",
      domicile_address: "",
      domicile_country_code: null,
      domicile_province_code: null,
      domicile_city_code: null,
      domicile_postal_code: null,
      correspondence_address: "",
      correspondence_country_code: null,
      correspondence_province_code: null,
      correspondence_city_code: null,
      correspondence_postal_code: "",
      agreementChecked: false,
      expChecked: true,
      failedShow: false,
      failedCorrespondence: false,
      failedDomicile: false,
      failedIdentity: false,
      failedDateOfBirth: false,
      errorMessage: false,
      isIdentityAddress: "",
      isDomicileAddress: "",
      isHidden: false,
      isHidden2: false,
      isHiddenDomicile: "",
      loading: false,
      processing: false,

      disabled: false,
      disabledAddress: false,
      agreement: true,
      seen: true,
      selectedIdCountry: "",
      selectedIdProvince: "",
    };
  },
  mounted() {
    this.fetchCountries();
    this.fetchProvinces();
    this.fetchCities();
    // this.first_name = this.user.individual.ifua_name;
    // this.correspondence_address = this.user.individual.correspondence_address;
  },
  created() {
    this.ifua_name = this.user.individual.ifua_name;
    this.correspondence_address = this.user.individual.correspondence_address;
    this.correspondence_country_code =
      this.user.individual.country_of_correspondence;
    this.identity_address = this.user.individual.ktp_address;
    this.domicile_address = this.user.individual.domicile_address;
  },
  computed: {
    ...mapGetters({
      bearer_token: "bearer_token",
      check: "auth/check",
      user: "auth/user",
      access_token: "auth/access_token",
    }),
    countryList() {
      return this.countries
        .concat()
        .sort((a, b) => a.country_name.localeCompare(b.country_name));
    },
    provinceList() {
      return this.provinces
        .concat()
        .sort((a, b) => a.province_name.localeCompare(b.province_name));
    },
    cityList() {
      return this.cities
        .concat()
        .sort((a, b) => a.city_name.localeCompare(b.city_name));
    },
    // provinceList: function() {
    //   function compare(a, b) {
    //     if (a.province_name < b.province_name)
    //       return -1;
    //     if (a.province_name > b.province_name)
    //       return 1;
    //     return 0;
    //   }

    //   return this.provinces.sort(compare);
    // },
    // cityList: function() {
    //   function compare(a, b) {
    //     if (a.city_name < b.city_name)
    //       return -1;
    //     if (a.city_name > b.city_name)
    //       return 1;
    //     return 0;
    //   }

    //   return this.cities.sort(compare);
    // },
  },
  methods: {
    selectIdCountry(e) {
      this.selectedIdCountry = e;
    },
    selectIdProvince(e) {
      this.selectedIdProvince = e;
    },
    checkIdentityIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.identity_address = this.correspondence_address;
        this.identity_city_code = this.correspondence_city_code;
        this.identity_province_code = this.correspondence_province_code;
        this.identity_country_code = this.correspondence_country_code;
        this.identity_postal_code = this.correspondence_postal_code;
        this.agreement = false;
        this.disabledAddress = true;
      } else {
        this.disabledAddress = false;
        this.agreement = true;
        this.identity_address = "";
        this.identity_city_code = "";
        this.identity_province_code = "";
        this.identity_country_code = "";
        this.identity_postal_code = "";
      }
    },
    checkOtherIdentityIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.disabledAddress = false;
        this.agreement = false;
        this.identity_address = "";
        this.identity_city_code = "";
        this.identity_province_code = "";
        this.identity_country_code = 130;
        this.identity_postal_code = "";
      }
    },
    checkDomicileIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.domicile_address = this.correspondence_address;
        this.domicile_city_code = this.correspondence_city_code;
        this.domicile_province_code = this.correspondence_province_code;
        this.domicile_country_code = this.correspondence_country_code;
        this.domicile_postal_code = this.correspondence_postal_code;
        this.agreement = false;
        this.disabledAddress = true;
      } else {
        this.disabledAddress = false;
        this.agreement = true;
        this.domicile_address = "";
        this.domicile_city_code = "";
        this.domicile_province_code = "";
        this.domicile_country_code = "";
        this.domicile_postal_code = "";
      }
    },
    checkOtherDomicileIsCorrespondenceAddress() {
      if (event.target.checked) {
        this.disabledAddress = false;
        this.agreement = false;
        this.domicile_address = "";
        this.domicile_city_code = "";
        this.domicile_province_code = "";
        this.domicile_country_code = 130;
        this.domicile_postal_code = "";
      }
    },
    async fetchCountries() {
      let response = await axios({
        method: "GET",
        url: "countries",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      this.countries = response.data.data;
    },
    async fetchProvinces() {
      let response = await axios({
        method: "GET",
        url: `provinces?country_id=${this.selectedIdCountry}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      this.provinces = response.data.data;
    },
    async fetchCities() {
      let response = await axios({
        method: "GET",
        url: `cities?province_id=${this.selectedIdProvince}`,
        headers: {},
      });
      this.cities = response.data.data;
    },
    handleSubmit() {
      if (!this.processing) {
        this.processing = true;
        if (this.correspondence_address == "") {
          this.failedCorrespondence = true;
        }

        if (this.correspondence_city_code == null) {
          this.failedCorrespondence = true;
        }

        if (this.correspondence_country_code == null) {
          this.failedCorrespondence = true;
        }

        if (this.correspondence_postal_code == "") {
          this.failedCorrespondence = true;
        }

        let formData = new FormData();

        formData.append("ifua_name", this.ifua_name);
        formData.append("identity_city_code", this.identity_city_code);
        formData.append("identity_address", this.identity_address);
        formData.append("identity_postal_code", this.identity_postal_code);
        formData.append("domicile_city_code", this.domicile_city_code);
        formData.append("domicile_address", this.domicile_address);
        formData.append("domicile_postal_code", this.domicile_postal_code);
        formData.append("domicile_country_code", this.domicile_country_code);
        formData.append(
          "correspondence_city_code",
          this.correspondence_city_code
        );
        formData.append("correspondence_address", this.correspondence_address);
        formData.append(
          "correspondence_postal_code",
          this.correspondence_postal_code
        );
        formData.append(
          "correspondence_country_code",
          this.correspondence_country_code
        );
        formData.append(
          "user_id",
          this.user.individual.user_id || this.user.institutional.user_id
        );
        formData.append(
          "id",
          this.user.individual.id || this.user.institutional.id
        );
        // console.log(formData);
        // return false;
        // for (var pair of formData.entries()) {
        //   console.log(pair[0] + ", " + pair[1]);
        // }

        let axiosConfig = {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${this.access_token}`,
          },
        };

        instance
          .post(
            "individual-account/change-individual-profile",
            formData,
            axiosConfig
          )
          .then((res) => {
            console.log("AXIOS SUCCESS: ", res);
            this.loading = !false;

            window.setTimeout(function () {
              window.location.href = "/";
            }, 2000);
          })
          .catch((err) => {
            console.log("AXIOS ERROR: ", err);
            this.failedShow = true;
            this.processing = false;

            // this.errorMessage = err.response.data.data.message;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-header-container {
  padding-top: 120px;
  padding-bottom: 40px;
}

.register-header-row {
  text-align: left !important;
}

.register-form {
  background: #f3f4f6;
}
.register-form-container {
  padding-top: 40px;
  padding-bottom: 60px;
}

h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  color: #111827;
}

h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #111827;
}

p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #4b5563;
}

span {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #4f566b;
}

.error {
  p {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #e53e3e !important;
  }
}

.register-header h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #111827;
}
.register-header p {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #6b7280;
}

.mx-input {
  height: 38px !important;
}

.mx-input:hover,
.mx-input:focus {
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
}

.vs-con-input-label {
  width: 100%;
}

.con-select {
  width: 100%;
  clear: both;
}

.con-vs-radio {
  justify-content: start;
}

.con-vs-checkbox {
  justify-content: start;
  margin: 0;
}

.ekyc-form-input h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #111827;
}

.ekyc-form-input p {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #6b7280;
}

.ekyc-form-input span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #9ca3af;
}

.ekyc-form-radio span {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #6b7280;
}

.ekyc-form-radio h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #374151;
}

.ekyc-form-radio p {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #9ca3af;
}

.ekyc-form-fatcha p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #374151;
}

.residental-address-checkbox h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #374151;
}

.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 100%;
}

.form-control:focus {
  outline: none !important;
  border: 1px solid !important;
  box-shadow: none !important;
}

.radio {
  position: relative;
  input[type="radio"] {
    opacity: 0;
  }
  label {
    padding-left: 10px;
    cursor: pointer;
    margin-bottom: 7px !important;
    &:before {
      width: 18px;
      height: 18px;
      position: absolute;
      top: 1px;
      left: 0;
      content: "";
      display: inline-block;
      -moz-border-radius: 50px;
      -webkit-border-radius: 50px;
      border-radius: 50px;
      border: 1px solid $secondaryColor;
      background: white;
    }
  }
  input[type="radio"] {
    margin: 0px;
    &:disabled + label {
      color: #999;
      &:before {
        background-color: $secondaryColor;
      }
    }
    &:checked + label::after {
      content: "";
      position: absolute;
      top: 5px;
      left: 4px;
      display: inline-block;
      font-size: 11px;
      width: 10px;
      height: 10px;
      background-color: $secondaryColor;
      -moz-border-radius: 50px;
      -webkit-border-radius: 50px;
      border-radius: 50px;
    }
  }
}

.radio-default input[type="radio"]:checked + label:before {
  border-color: $secondaryColor;
}

.ekyc-form-radio input[type="radio"]:checked + label {
  &:before {
    border-color: $secondaryColor;
  }
  &::after {
    background-color: $secondaryColor;
  }
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: $secondaryColor;
}

.custom-checkbox:active {
  box-shadow: none !important;
}
.custom-checkbox:focus {
  box-shadow: none !important;
}

.custom-control-label {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #111827;
}

.jumbotron {
  padding: 0;
  background-color: white;
  opacity: 1;
}

.modal-register {
  z-index: 99999;
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    text-align: center;
    color: black;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    text-align: center;
    color: #4b5563;
  }
}

.btn-add-bank {
  font-family: $inter;
  background: transparent;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  color: #3f0975;
  border: 1px solid #3f0975;
  border-radius: 6px;
}

.btn-tertiary:disabled {
  cursor: no-drop;
}

.btn-dark:focus {
  box-shadow: none !important;
}

.dropbox {
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  top: 200; /* minimum height */
  position: relative;
  border-radius: 5px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  cursor: pointer;
}

.dropbox:hover {
  outline: 2px dashed grey; /* the dash box */ /* when mouse over to the drop zone, change color */
}

.dropbox p {
  position: relative;
  font-size: 1.2em;
  text-align: center;
  top: 50px;
}

.dropbox-signature {
  background: white;
  height: 200px;
  border-radius: 5px;
}
.dropbox-signature:hover {
  outline: 2px dashed grey; /* the dash box */
}

.selfie-instruction {
  margin-top: 64px;
}

@media only screen and (max-width: 768px) {
  .register-header-row {
    text-align: center !important;
  }
  .btn-dark {
    margin-bottom: 18px;
  }
  .btn-submit-row {
    justify-content: center !important;
  }
  .header-modal {
    font-size: 16px !important;
  }
  .selfie-instruction {
    margin-top: 0px;
  }
}
</style>